import * as React from "react";
import {
  Box, List, ListItemButton, ListItemText, Typography, Divider, CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import { listSchedules, type ScheduleSummary } from "../../api/schedules";

const MAX_SHOWN = 3;

export function SchedulesSection() {
  const [schedules, setSchedules] = React.useState<ScheduleSummary[] | null>(null);

  React.useEffect(() => {
    listSchedules()
      .then(setSchedules)
      .catch(() => setSchedules([]));
  }, []);

  if (schedules === null) {
    return (
      <Box sx={{ p: 1, textAlign: "center" }}>
        <CircularProgress size={16} />
      </Box>
    );
  }

  const shown = schedules.slice(0, MAX_SHOWN);
  const overflow = schedules.length - shown.length;

  // Inside the side panel's `sp` scope. Rows all lead to the Schedules page,
  // so a row is `open` (by kind) and the overflow/empty links are `open_all`.
  return (
    <div data-ph-scope="schedules">
      <Typography
        variant="overline"
        sx={{ display: "block", px: 2, pt: 1, color: "text.secondary" }}
      >
        Schedules
      </Typography>
      <List dense>
        {shown.map((s) => (
          <ListItemButton
            key={s.id}
            component={Link}
            to="/workspace/schedules"
            data-ph="open"
          >
            <ListItemText
              primary={s.name}
              slotProps={{ primary: { noWrap: true } }}
            />
          </ListItemButton>
        ))}
        {overflow > 0 && (
          <ListItemButton component={Link} to="/workspace/schedules" data-ph="open_all">
            <ListItemText
              primary={`${overflow} more →`}
              slotProps={{ primary: { color: "text.secondary" } }}
            />
          </ListItemButton>
        )}
        {schedules.length === 0 && (
          <ListItemButton component={Link} to="/workspace/schedules" data-ph="open_all">
            <ListItemText
              primary="View schedules"
              slotProps={{ primary: { color: "text.secondary" } }}
            />
          </ListItemButton>
        )}
      </List>
      <Divider />
    </div>
  );
}
